var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.isFont === true && _vm.icon && _vm.icon !== '') || _vm.isFont === false)?_c(_vm.isFont === true ? 'i' : 'div',{tag:"component",class:['a-icons', _vm.getIcon, _vm.getSize]},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }